import state from '@/state'
import { df } from '@/plugins/firebase'
import { printOrder } from '@/libs/bixolon/order'
import EventBus from '@/plugins/event-bus'

export default {
  data () {
    return {
      printedOrderOrgUnits: new Set() // Track printed order+orgUnit combinations to prevent duplicates
    }
  },
  methods: {
    tables () {
      var printers = this.getPrinters()
      var orgUnits = this.getOrgUnits()
      var listeners = []
      const query = df.collection(`location_orders/${state.getOrderPrintLocation().id}/tables`).orderBy('number')
      const listener = query.onSnapshot((doc) => {
        if (doc.metadata.fromCache) return

        console.log('🔵 [tables.js] onSnapshot triggered, changes:', doc.docChanges().length)
        doc.docChanges().forEach((change) => {
          var table = change.doc.data()
          console.log('🔵 [tables.js] Change type:', change.type, 'table:', table.name, 'orders:', table.orders?.length)
          console.log(change)
          var items = this.getItems(table)
          console.log('🔵 [tables.js] Items found:', Object.keys(items).length, 'org units')
          var otherUnits = this.checkOtherOrgUnits(items, orgUnits)
          console.log('🔵 [tables.js] Calling groupPrint...')
          this.groupPrint(items, printers, orgUnits, table, otherUnits)
        })
      })

      listeners.push(listener)
    },
    getItems (table) {
      var itemsInOrgUnits = {}

      // Check if table has orders
      if (!table || !table.orders || table.orders.length === 0) {
        return itemsInOrgUnits
      }

      var order = table.orders[table.orders.length - 1]
      var itemsToProcess = []

      // NEW: Check if order has courses array (new structure from external systems like Orderman)
      if (order && order.courses && order.courses.length > 0) {
        console.log('🔵 [tables.js] Order has courses structure, flattening...')
        // Flatten courses: extract items and attach course context
        order.courses.forEach((course, courseIndex) => {
          if (course.items && course.items.length > 0) {
            course.items.forEach(item => {
              // Add course metadata to item for printing
              itemsToProcess.push({
                ...item,
                course_id: course.id,
                course_name: course.name,
                course_index: courseIndex  // To maintain array order during print
              })
            })
          }
        })
        console.log('🔵 [tables.js] Flattened', itemsToProcess.length, 'items from', order.courses.length, 'courses')
      }
      // EXISTING: Fall back to order_items if no courses
      else if (order && order.order_items && order.order_items.length > 0) {
        itemsToProcess = order.order_items
      }

      // Group by organizational_unit_id (unchanged logic)
      itemsToProcess.forEach(item => {
        console.log('🔵 [tables.js] Processing item:', item.name, 'org_unit_id:', item.organizational_unit_id)
        if (!item.quantity) {
          console.log('🔵 [tables.js] Item quantity is 0/missing (discount-only change), skipping print')
          return
        }
        if (item.organizational_unit_id && item.organizational_unit_id !== '') {
          if (!itemsInOrgUnits[item.organizational_unit_id]) {
            itemsInOrgUnits[item.organizational_unit_id] = []
          }
          itemsInOrgUnits[item.organizational_unit_id].push(item)
          console.log('🔵 [tables.js] Item added to org unit:', item.organizational_unit_id)
        } else {
          console.log('🔵 [tables.js] Item has no org_unit_id, skipping')
        }
      })

      return itemsInOrgUnits
    },
    getPrinters () {
      this.printers = []
      var query = df.collection(`location_printers/${state.getOrderPrintLocation().id}/printers`)
      query.onSnapshot((doc) => {
        doc.docs.forEach((rec) => {
          this.printers.push(rec.data())
        })
      })

      return this.printers
    },
    getOrgUnits () {
      this.orgUnits = []
      const query = df.collection(`location_units/${state.getOrderPrintLocation().id}/units`)
      query.onSnapshot((doc) => {
        doc.docs.forEach((rec) => {
          this.orgUnits.push(rec.data())
        })
      })
      return this.orgUnits
    },
    groupPrint (itemsInOrgUnits, printers, orgUnits, table, otherUnits) {
      // Guard clause: check if table has orders
      if (!table || !table.orders || table.orders.length === 0) {
        console.log('🔵 [tables.js] groupPrint - no orders in table, skipping')
        return
      }

      const lastOrder = table.orders[table.orders.length - 1]

      Object.keys(itemsInOrgUnits).forEach(unitId => {
        const orgUnit = orgUnits.find(u => u.id === unitId)

        if (orgUnit) {
          const printer = printers.find(p =>
            p.id === orgUnit.printer || p.name === orgUnit.printer
          )

          if (printer) {
            this.callPrinter(itemsInOrgUnits[unitId], printer, orgUnit, table, lastOrder, otherUnits)
          }
        }
      })
    },
    checkOtherOrgUnits (itemsInOrgUnits, orgUnits) {
      var otherUnits = []

      if (!itemsInOrgUnits || !orgUnits) {
        return otherUnits
      }

      Object.keys(itemsInOrgUnits).forEach(unitId => {
        const orgUnit = orgUnits.find(u => u.id === unitId)
        if (orgUnit) {
          otherUnits.push(orgUnit)
        }
      })

      return otherUnits
    },
    async callPrinter (items, printer, orgUnit, table, order, otherUnits) {
      console.log('🟢 [tables.js] callPrinter - order status:', order.order_status, 'order:', order.id, 'orgUnit:', orgUnit.id)

      // Create composite key for tracking this specific order+orgUnit combination
      const printKey = `${order.id}-${orgUnit.id}`

      // Check if already printed this order for this org unit
      if (this.printedOrderOrgUnits.has(printKey)) {
        console.log('🟢 [tables.js] Order already printed for this org unit, skipping')
        return
      }

      let note = null
      if (order.notes) {
        const unitNote = order.notes.find(n => n.unitId === orgUnit.id)
        if (unitNote) note = unitNote
      }
      if (!note && order.order_note) {
        note = { message: order.order_note }
      }

      if (order.order_status === 'ORDERED') {
        console.log('🟢 [tables.js] Status is ORDERED, printing now for orgUnit:', orgUnit.name)

        // Mark as printed BEFORE printing to prevent race conditions
        this.printedOrderOrgUnits.add(printKey)

        state.setPosPrinterSettings(2)

        try {
          const result = await printOrder(items, printer, table, order, orgUnit, otherUnits, note, this.hideLoader)

          if (result && result.success) {
            console.log('🟢 [tables.js] Print successful for orgUnit:', orgUnit.name, '- updating status to PRINTED')
            this.updateOrderPrinted(table, order)
          } else {
            // Remove from printed set if failed
            this.printedOrderOrgUnits.delete(printKey)
            console.error('🔴 [tables.js] Print failed for orgUnit:', orgUnit.name, '- error:', result ? result.error : 'Unknown error')

            // Show error modal dialog
            const errorMsg = result && result.error ? result.error : 'Nepoznata greška'
            EventBus.$emit('show-message-box', {
              title: 'Greška pri printanju',
              subtitle: table.name || 'Stol',
              text: `Printanje nije uspjelo: ${errorMsg}\n\nProvjerite printer i pokušajte ponovno.`,
              color: 'error',
              actions: ['ok'],
              okBtnText: 'U redu',
              width: '500'
            })

            // Also show error notification (non-blocking snackbar)
            if (this.$root && this.$root.$emit) {
              this.$root.$emit('show-snackbar', {
                text: `⚠️ Printanje za ${table.name} nije uspjelo. Provjerite printer.`,
                color: 'error',
                timeout: 5000
              })
            }
          }
        } catch (err) {
          // Remove from printed set if failed
          this.printedOrderOrgUnits.delete(printKey)
          console.error('🔴 [tables.js] Print exception for orgUnit:', orgUnit.name, '- error:', err)

          // Show error modal dialog
          EventBus.$emit('show-message-box', {
            title: 'Greška pri printanju',
            subtitle: table.name || 'Stol',
            text: `Printanje nije uspjelo: ${err.message || 'Nepoznata greška'}\n\nProvjerite printer i pokušajte ponovno.`,
            color: 'error',
            actions: ['ok'],
            okBtnText: 'U redu',
            width: '500'
          })

          // Also show error notification
          if (this.$root && this.$root.$emit) {
            this.$root.$emit('show-snackbar', {
              text: `⚠️ Printanje za ${table.name} nije uspjelo: ${err.message}`,
              color: 'error',
              timeout: 5000
            })
          }
        }
      } else {
        console.log('🟢 [tables.js] Status is NOT ORDERED, skipping print')
      }
    },
    updateOrderPrinted (table, order) {
      table.orders.forEach((or, key) => {
        if (order.id === or.id) {
          table.orders[key].order_status = 'PRINTED'
        }
      })

      df.doc(`location_orders/${state.getOrderPrintLocation().id}/tables/${table.id}`).update({ orders: table.orders })
        .catch((err) => {
          console.error(err)
          this.showMsgBox({ text: `Pogreška prilikom promjene status narudžbe: ${err}`, actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        })
      console.log(table)
    }
  }

}
